import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
const config = require('../../../assets/config/development.js'); // config file to get the url
import { environment } from '../../../environments/environment';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { _ } from 'underscore';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-getstarted',
  templateUrl: './getstarted.component.html',
  styleUrls: ['./getstarted.component.css'],
})
export class GetstartedComponent implements OnInit, AfterViewInit {
  url = environment.api_url;
  mybutton;

  queryObj = {
    hg_accountId: null,
  };

  constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private title: Title,
    private meta: Meta,
    private http: HttpClient
  ) {}
  ngOnInit() {
    this.title.setTitle(
      'Energy Service for Renters and Homeowners, Powered by AI'
    );
    this.meta.updateTag({
      name: 'keywords',
      content:
        'ai,artificial intelligence,energy bot,energy chatbot,get started,residential energy,shop for electricity for my home,need electricity asap,home energy,apartment,switch providers,new service,smart home,how do I save money on electricity bills,how do I save energy,I am moving and need to find a new electricity provider,movers,real estate agent,buying a home,renting a home,renting an apartment,Zillow,redfin,keller Williams,remax,c21,rogershealy,compass,Coldwell banker,apartment finders,smartcity apartment locating,Houston,Dallas,Richardson,Mesquite,Irving,Arlington,Amli,Lincoln Property Company,leasing an apartment,honest recommendation,lowest electricity price,cheapest electricity price,TXU,Reliant,Green Mountain,compare power companies,light companies,power to choose,save on energy,Texas electricity rates,Texas electricity prices,electric choice,energy deregulation,dereg101,cheap electricity deal,choose my electric company,Griddy,Frontier Utilities,Ambit Energy,Stream Energy,free nights and weekends,google home,energy plans,new home,new apartment,electric choice',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'Honest Gorilla is your one stop to shop for a better energy plan that fits your budget, lifestyle and household. Shop and compare today!',
    });
    this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });

    $(window).scroll(function () {
      const scrollPos = $(window).scrollTop(),
        navH = $('nav').height();
      let mybutton = document.getElementById('myBtn');
      $('.sections').each(function (i) {
        const offT = $(this).offset().top;
        if (offT - scrollPos - navH <= 0) {
          $('.active').removeClass('active');
          $('.navigate li').eq(i).addClass('active');
        }
      });
    });
    $('.navigate li').click(function () {
      $('.navigate li').removeClass('active');
      $(this).addClass('active');
    });

    setTimeout(() => {
      const letsgoScroll = document.getElementsByTagName('html');
      if (letsgoScroll[0].classList.contains('letsgo')) {
        letsgoScroll[0].classList.remove('letsgo');
      }
    }, 30);
  }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }
  getslide(param) {
    param.scrollIntoView({ behavior: 'smooth' });
  }

  getQuestionnaire() {
    //alert("jjjjj");
    if (
      !_.isEmpty(sessionStorage.getItem('userObj')) &&
      _.isEmpty(sessionStorage.getItem('postresult'))
    ) {
      const currentUser = JSON.parse(sessionStorage.getItem('userObj'));
      var hg_accountId = currentUser.hg_accountId
        ? currentUser.hg_accountId
        : currentUser._id;

      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }

      const body = new HttpParams().append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;

      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (
              result.user.questionStatusObj != null &&
              result.user.questionStatusObj.questionStatus != 'Completed' &&
              result.userResponses &&
              result.userResponses.length > 0
            ) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;
                  sessionStorage.removeItem('questionStatusObj');
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  console.log(sessionStorage.getItem('userResponse'));
                  this.residentialService.messageService({});
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              this.residentialService.userResponse.userResponses = [];
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }
      this.residentialService.userResponse.userResponses = [];
      if (
        this.residentialService.userResponse.userResponses != null &&
        this.residentialService.userResponse.userResponses.length > 0
      ) {
        sessionStorage.clear();
        this.router.navigateByUrl('/residentialQues');
        this.residentialService.messageService({
          currentId: null,
          questionStatus: null,
        });
        // }
      } else {
        if (!sessionStorage.getItem('Promocode')) {
          sessionStorage.clear();
        }
        this.residentialService.messageService({});
        this.router.navigateByUrl('/residentialQues');
      }
    }
  }

  getQuestionnaire_old() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      var hg_accountId = JSON.parse(sessionStorage.getItem('userObj'))._id;
      JSON.parse(
        sessionStorage.getItem('userObj')
      ).questionStatusObj.percentage = '';
      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }

      const body = new HttpParams().append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;

      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (result.userResponses && result.userResponses.length > 0) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;
                  console.log('delete record successfully!!!', notifyresult);
                  sessionStorage.removeItem('questionStatusObj');
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  console.log(sessionStorage.getItem('userResponse'));
                  this.residentialService.messageService({});
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }
      if (
        this.residentialService.userResponse.userResponses != null &&
        this.residentialService.userResponse.userResponses.length > 0
      ) {
        if (
          this.residentialService.questionnaireStatusObj.questionStatus ===
            'Completed' &&
          this.residentialService.user.accountId
        ) {
          this.router.navigate(['pre-success']);
        } else {
          this.router.navigateByUrl('/residentialQues');
          this.residentialService.messageService({
            currentId: null,
            questionStatus: null,
          });
        }
      } else {
        this.residentialService.messageService({});
        this.router.navigateByUrl('/residentialQues');
      }
    }
  }
}
